// Registers service-worker.js once on app load. Harmless no-op on browsers
// without support, and does nothing further until a user actually turns
// notifications on (see notifications.js) — registering alone requests no
// permissions and subscribes to nothing.
//
// Also detects when a NEW build's service worker has installed and taken
// over from a previous one (as opposed to the very first install, which
// isn't an "update"), and calls onUpdateReady so the app can prompt a
// tap-to-refresh instead of silently sitting on stale JS until the device
// happens to be fully closed and reopened.
export function registerServiceWorker(onUpdateReady) {
    if (!('serviceWorker' in navigator)) return Promise.resolve(null);

    return navigator.serviceWorker.register('/service-worker.js').then((registration) => {
        function trackInstalling(worker) {
            worker.addEventListener('statechange', () => {
                // A controller already existing means some earlier SW was
                // already running this page — so this "installed" is a real
                // update, not the first-ever install.
                if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                    onUpdateReady?.();
                }
            });
        }

        if (registration.installing) trackInstalling(registration.installing);
        registration.addEventListener('updatefound', () => {
            if (registration.installing) trackInstalling(registration.installing);
        });

        // Chrome doesn't proactively re-check a backgrounded tab's SW very
        // often — nudge it whenever the tab (re)gains visibility, which is
        // exactly when a scanner app gets reopened after being set down.
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') registration.update().catch(() => {});
        });

        return registration;
    }).catch(() => null);
}
